import { PRODUCT_TYPES } from '../utils/catalog';
import { isNumber } from '@bitComponents/utils/common';

export const PURCHASE_TYPE = {
  AUTOMATIC: 'automatico',
  AUTOMATIC_ERROR: 'automatico-error',
  MANUAL: 'manual',
};

export const SELF_EMPLOYED_SUFFIX = '-autonomo';

export const replaceCommaByDot = (alias) => {
  if (alias) {
    return alias.replace(',', '.');
  }

  return '';
};

export const generateAliasSellingProduct = (productOfferingsToBuyInfo, allPOsToBuy, isSelfEmployedFlow) => {
  let alias = '';
  allPOsToBuy.forEach((po) => {
    if (productOfferingsToBuyInfo && productOfferingsToBuyInfo[po] && productOfferingsToBuyInfo[po].productOfferingName) {
      let productOfferingname = productOfferingsToBuyInfo[po].productOfferingName;
      if (isSelfEmployedFlow) {
        productOfferingname += SELF_EMPLOYED_SUFFIX;
      }
      alias = alias ? `${alias};${productOfferingname}` : `${productOfferingname}`;
    }
  });
  return replaceCommaByDot(alias);
};

export const normalizeSelectElementsTaggingChoices = (selectElementsNeeds) => {
  let choices = '';
  if (selectElementsNeeds.actionId) {
    if (selectElementsNeeds.productType) {
      choices = `${selectElementsNeeds.productType || PRODUCT_TYPES.OTHER}:${selectElementsNeeds.actionId}`;
    }
  }
  if (selectElementsNeeds.secondarySelection && Array.isArray(selectElementsNeeds.secondarySelection) && selectElementsNeeds.secondarySelection.length > 0) {
    selectElementsNeeds.secondarySelection.forEach((action) => {
      choices = `${choices}:${action.productType}:${action.actionId}`;
    });
  }
  return choices;
};

/**
 * Función que se usa para enviar el taggeo de página
 * @param {object} taggingData Objeto con la información de taggeo, tiene que ser de la forma:
 * <pre>
 *                - purchaseType: Automático, manual o automático-error
 *                - stepName: Nombre del paso que se está visualizando
 *                - aliasSellingProduct: Nombre del producto principal que se está comprando
 *                - allPOsToBuy: array de POid de los productos que se están comprando
 *                - choices: elecciones del cliente
 *                - price: precio total recurrente
 *                - cq: id de CQ si existe
 *                - co: id de la CO si existe
 *                - allPromosId: array de promociones aplicadas
 * </pre>
 */
export const sendBuyProcessTagging = (taggingData) => {
  if (window && window.nookInfoExchange && taggingData) {
    const {
      purchaseType, // si hay co o no, solo se pondrá a manual en confirmación sin CO
      stepName, // configuracion
      aliasSellingProduct, // parametro
      allPOsToBuy, // array de POs
      buyProcess, // configuración
      choices,
      regularPrice, // groupPriceBeforeDiscounts del recurringCharges
      price, // groupPrice del recurringCharges
      cq, // cq
      co, // co
      idSE, // idSE
      allPromosId, // promoción aplicada
      zipCode, // libre o regulada
      userType, // Tipo de usuario (Telco , '')
      paymentMethod, // Forma de pago, por defecto 'domiciliacion'
      isSelfEmployedFlow,
      allPOsToDowngrade,
      downgradesAlias,
      speedId,
    } = taggingData;
    let buyProcessName = buyProcess;
    if (isSelfEmployedFlow) {
      buyProcessName += SELF_EMPLOYED_SUFFIX;
    }

    window.nookInfoExchange.sendMessage('AppController-ExtraPageInfo', {
      'purchase-type': purchaseType || PURCHASE_TYPE.AUTOMATIC,
      'page-product-code': '',
      ...(aliasSellingProduct && { 'page-product-name': aliasSellingProduct }),
      ...(choices && {
        'purchase-mode': choices,
      }),
      'purchase-process': buyProcessName,
      ...(stepName && { 'purchase-stepname': stepName }),
      'purchase-payment-method': paymentMethod,
      ...(isNumber(regularPrice) && { 'purchase-regular-price': `${regularPrice}` }),
      ...(isNumber(price) && { 'purchase-price': `${price}` }),
      'purchase-ion-code': allPOsToBuy || '',
      'product-characteristic': speedId || '',
      'purchase-downgrades-code': allPOsToDowngrade || '',
      'purchase-downgrades-name': downgradesAlias || '',
      ...((co || idSE) && { 'purchase-customer-order': co || idSE }),
      ...(cq && { 'purchase-customer-quote': cq }),
      ...(allPromosId && { 'purchase-promotion-code': allPromosId }),
      'zip-code': zipCode || '',
      'user-type': userType === '' ? 'no-cliente' : userType,
    });
  }
};
